import React, { useState, Fragment, useRef, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { Button } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import { useSelector, useDispatch } from "react-redux";
import Toastr from "../../components/common/Toastr";
import SignatureCanvas from "react-signature-canvas";
import { useNavigate, useLocation } from "react-router-dom";
import OrderDatatable from "./_OrderDatatable";
import { masterActions, orderActions } from "../../../_store";
import Select from "react-select";
import emptyImage from "../../../images/no-image-png-2.png";
import {
  Html5Qrcode,
  Html5QrcodeScanner,
  Html5QrcodeSupportedFormats,
} from "html5-qrcode";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

const { REACT_APP_API_IMAGE_URL } = process.env;

const DispatchDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  let navigate = useNavigate();
  //let padRef = useRef()
  const inputRef = useRef(null);
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // #region ------------------  Reducer --------------------------------
  const currentUser = useSelector((x) => x.auth.user);
  const dispatchDetailsResponse = useSelector(
    (state) => state.order.dispatchDetailsResponse
  );
  const courierTypeDrpList = useSelector((x) => x.master.courierTypeDrpList);

  //  const GetDispatchDetailID = useSelector((x) => x.order.GetDispatchDetailID)
  const dispatchDetailsList = useSelector(
    (state) => state.order.dispatchDetailsList
  );
  const skidBreakdownDetailsList = useSelector(
    (state) => state.order.skidBreakdownDetailsList
  );
  const [scanResults, setScanResults] = useState({});
  const [isVerifySuccess, setIsVerifySuccess] = useState(0); // Track verification status

  // #endregion ------------------  Reducer End --------------------------------

  const listView = location.state;
  const [submitted, setSubmitted] = useState(false);
  let styles = {
    control: (styles) => ({ ...styles, border: "1px solid red" }),
  };

  const [addDispatchDetails, setDispatchDetails] = useState({
    OrderID: 0,
    OrderNumber: listView?.OrderNumber,
    ClientID: 0,
    AssignedDispatcherID: 0,
    CourierTypeID: 0,
    DispatchWeight: 0,
    DigitalSignaturePath: "",
    // TrackingNumber: "",
    BillFilePath: "",
    ImageBase64: "",
    CourierTypeOptions: null,
    TypeOrderTrackingModel: [],
    Status: 1,
    CreatedBy: currentUser.Id,
    IsSkipBOL: 0,
  });

  const [TrackingFields, setTrackingFields] = useState([
    {
      OrderID: listView.OrderID,
      OrdTrackingNumberID: 0,
      TrackingNumber: "",
      Status: 1,
    },
  ]);

  const newAddDispatchDetails = { ...addDispatchDetails };
  const sigRef = useRef();
  //const [TrackingFields, setTrackingFields] = useState([]);
  const [fieldErrors, setFieldErrors] = useState([]);
  const [FieldError, setFieldError] = useState(false);
  const [showReScan, setShowReScan] = useState(false); // ✅ State for "ReScan" button

  // Skid Breakdown
  const [skidBreakdown, setSkidBreakdown] = useState({
    OrderID: 0,
    TotalSkidWeight: 0,
    CreatedBy: currentUser.Id,
    TypeOrderSkidBreakdownModel: [],
    IsOrderSkidBreakdown: false,
    IsOrderSkid: false,
  });

  const handleAddFields = () => {
    const IsTrackingNumberExist = TrackingFields.some(
      (item, index) => item.TrackingNumber === ""
    );

    if (IsTrackingNumberExist) {
      Toastr("Please fill in the required missing fields", "warning");
    } else {
      const newTrackingField = {
        OrderID: listView.OrderID,
        OrdTrackingNumberID: 0,
        TrackingNumber: "",
        Status: 1,
      };
      setTrackingFields((prevFields) => [...prevFields, newTrackingField]);
      setFieldError(true);
    }
    setFieldError(true);

    // Add a new field and initialize its error state
    // Initialize the error state for the new field
    setFieldErrors((prevErrors) => [
      ...prevErrors,
      {
        TrackingNumber: true,
      },
    ]);
    // No error initially
  };
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;

    if (TrackingFields[index].TrackingNumber === "") {
      setFieldError(true);
      // setSubmitted(false)
    }
    // Update the field value
    const updatedFields = [...TrackingFields];
    updatedFields[index][name] = value;
    setTrackingFields(updatedFields);

    // Validate the field and update error state
    const updatedErrors = [...fieldErrors];
    updatedErrors[index][name] = value.trim() === ""; // Set error if value is empty
    setFieldErrors(updatedErrors);
    // setFieldError(false)
  };

  const handleRemoveFields = (index) => {
    const values = [...TrackingFields];
    values.splice(index, 1);
    setTrackingFields(values);
  };

  const handleSignatureEnd = () => {
    // setSignature(sigRef.current.toDataURL());
    newAddDispatchDetails.DigitalSignaturePath = sigRef.current.toDataURL();
    setDispatchDetails(newAddDispatchDetails);
  };
  const clearSignature = (e) => {
    sigRef.current.clear();
    newAddDispatchDetails.DigitalSignaturePath = "";
    // newAddDispatchDetails.ImageBase64 = newAddDispatchDetails.DigitalSignaturePath = "";
    setDispatchDetails(newAddDispatchDetails);
  };

  useEffect(() => {
    if (listView && listView.OrderStatusID === 7) {
      dispatch(orderActions.GetDispatchDetailID({ OrderID: listView.OrderID }));
    }
  }, [listView]);

  useEffect(() => {
    if (dispatchDetailsList && listView && listView.OrderStatusID === 7) {
      const selectedCourier = courierTypeDrpList.find(
        (x) => x.CourierTypeID === dispatchDetailsList.CourierTypeID
      );

      newAddDispatchDetails.OrderID = dispatchDetailsList.OrderID;
      newAddDispatchDetails.TypeOrderTrackingModel =
        dispatchDetailsList?.TypeOrderTrackingModel;
      newAddDispatchDetails.DispatchWeight = dispatchDetailsList.DispatchWeight;
      newAddDispatchDetails.DigitalSignaturePath =
        dispatchDetailsList.DigitalSignaturePath;
      newAddDispatchDetails.CourierTypeID = dispatchDetailsList.CourierTypeID;
      newAddDispatchDetails.BillFilePath = dispatchDetailsList.BillFilePath;

      newAddDispatchDetails.CourierTypeOptions = {
        value: dispatchDetailsList.CourierTypeID,
        label: dispatchDetailsList.CourierTypeName,
        IsSkipBOL: selectedCourier?.IsSkipBoL ?? 0,
      };

      newAddDispatchDetails.IsSkipBOL = selectedCourier?.IsSkipBoL ?? 0;

      setDispatchDetails(newAddDispatchDetails);
      setTrackingFields(newAddDispatchDetails.TypeOrderTrackingModel);
    }

    if (listView?.OrderID) {
      dispatch(
        orderActions.GetOrderSkidBreakDownID({ OrderID: listView.OrderID })
      );
    }
  }, [dispatchDetailsList, courierTypeDrpList]);

  useEffect(() => {
    let CourierTypeID = 0;
    let Status = 1;
    dispatch(masterActions.GetCourierTypeDrpList({ CourierTypeID, Status }));
  }, []);

  //no access
  useEffect(() => {
    if (listView.OrderStatusID !== 7) {
      if (
        !skidBreakdownDetailsList ||
        !skidBreakdownDetailsList.TypeOrderSkidBreakdownModel?.length
      ) {
        console.warn("🚨 TypeOrderSkidBreakdownModel is undefined or empty");
        return;
      }

      const orderID = listView.OrderNumber;
      const skiDIndexes =
        skidBreakdownDetailsList.TypeOrderSkidBreakdownModel.map(
          (item) => item.SkidIndex
        );

      let scannerInstances = [];

      // ✅ Apply custom styles
      const applyCustomStyles = () => {
        const style = document.createElement("style");
        style.innerHTML = `
      #html5-qrcode-anchor-scan-type-change { display: none !important; }
      img[alt="Info icon"] { display: none !important; }

      /* No Access Warning Style */
      .no-access-warning {
        color: red;
        font-weight: bold;
        display: block;
        text-align: center;
        margin-top: 10px;
      }

      /* Styled Camera Permission Button */
      #html5-qrcode-button-camera-permission {
        background-color: #007bff; /* Blue */
        color: white;
        font-size: 14px;
        font-weight: normal;
        padding: 8px 15px;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        transition: background 0.3s ease-in-out;
        display: block;
        margin: 10px auto;
      }

      #html5-qrcode-button-camera-permission:hover {
        background-color: #0056b3; /* Darker Blue */
      }
      #html5-qrcode-button-camera-stop {
  background-color: #dc3545; /* Red */
  color: white;
  font-size: 14px;
  font-weight: normal;
  padding: 10px 18px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease-in-out, transform 0.2s;
  display: block;
  margin: 10px auto;
  width: 90%; /* Responsive width */
  max-width: 250px; /* Limit button width */
  text-align: center;
}

/* Hover & Active Effects */
#html5-qrcode-button-camera-stop:hover {
  background-color: #c82333; /* Darker Red */
}

#html5-qrcode-button-camera-stop:active {
  transform: scale(0.95);
}
 /* ✅ Apply Blue Border to All Scan Regions */
      [id^="reader-"]__scan_region {
        border: 3px solid #007bff !important; /*  Border */
        border-radius: 10px; /* Rounded Corners */
        padding: 10px;
        max-width: 90%; /* Responsive */
        margin: 10px auto;
        box-shadow: 0px 4px 8px #007bff; /* Soft Glow */
      }
      
      @media (max-width: 768px) {
        [id^="reader-"]__scan_region {
          border-width: 2px;
          padding: 8px;
        }
      }

        /* ✅ Start Scanning Button - Styled */
  #html5-qrcode-button-camera-start {
    background-color: #007bff ; /* ✅ Blue for Start */
    color: white;
    font-size: 14px;
    font-weight: normal;
    padding: 10px 18px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.3s ease-in-out, transform 0.2s;
    display: block;
    margin: 10px auto;
    box-shadow: 0px 4px 8px #007bff;
  }

  #html5-qrcode-button-camera-start:hover {
    background-color:#007bff; /* Darker green on hover */
    transform: scale(1.05);
  }

  #html5-qrcode-button-camera-start:active {
    background-color:#007bff;
    transform: scale(0.98);
  }

  @media (max-width: 768px) {
    #html5-qrcode-button-camera-start {
      font-size: 12px;
      padding: 8px 15px;
    }
  }
#html5-qrcode-select-camera {
  background-color: #6c757d; /* ⚪ Neutral Gray (matches Camera Permission button) */
  color: white;
  font-size: 12px;
  font-weight: normal;
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease-in-out, transform 0.2s;
  display: block;
  margin: 10px auto;
  width: 90%;
  max-width: 250px;
  text-align: center;
}

/* Hover Effect */
#html5-qrcode-select-camera:hover {
  background-color: #5a6268; /* Slightly darker gray */
}

/* Focus Effect */
#html5-qrcode-select-camera:focus {
  outline: none;
  box-shadow: 0px 0px 8px rgba(108, 117, 125, 0.8); /* Soft glow */
}

/* Dropdown Options */
#html5-qrcode-select-camera option {
  background-color: #fff; /* White background for options */
  color: #000; /* Black text */
  font-size: 14px;
}

    `;
        document.head.appendChild(style);
      };

      applyCustomStyles();

      // ✅ Get cameras and handle access
      Html5Qrcode.getCameras()
        .then((devices) => {
          if (!devices || devices.length === 0) {
            console.warn(
              "🚨 No cameras found. Displaying 'No Access' warning."
            );

            // ❌ No cameras found: Set a warning message for each scan column
            skiDIndexes.forEach((index) => {
              const scanElement = document.getElementById(`reader-${index}`);
              if (scanElement) {
                scanElement.innerHTML = `<span class="no-access grey-text">🚫 No Access Camera</span>`;
              }
            });

            return;
          }

          console.log("📸 Available Cameras:", devices);

          // ✅ Find the back camera
          // let backCamera = devices.find((device) =>
          //   device.label.toLowerCase().includes("back")
          // );
          // let selectedCameraId = backCamera ? backCamera.id : devices[devices.length - 1].id;
          // console.log("🎯 Selected Back Camera ID:", selectedCameraId);

          skiDIndexes.forEach((index) => {
            if (!scanResults[index]) {
              const scannerInstance = new Html5QrcodeScanner(
                `reader-${index}`,
                {
                  qrbox: { width: 180, height: 180 },
                  fps: 5,
                  rememberLastUsedCamera: false,
                  //facingMode: { exact: "environment" }, // ✅ Forces the back camera
                  formatsToSupport: [
                    Html5QrcodeSupportedFormats.QR_CODE,
                    Html5QrcodeSupportedFormats.CODE_128,
                  ],
                },
                false
              );

              const handleScanSuccess = (result) => {
                const expectedValue = `${orderID}-${index}`;

                if (result === expectedValue) {
                  setScanResults((prevResults) => {
                    const updatedResults = { ...prevResults, [index]: result };

                    Toastr(`Scan Successful! Scanned: ${result}`, "success");

                    const allVerified = skiDIndexes.every(
                      (idx) => updatedResults[idx] === `${orderID}-${idx}`
                    );
                    setIsVerifySuccess(allVerified ? 1 : 0);
                    setShowReScan(true);

                    return updatedResults;
                  });
                } else {
                  Toastr(
                    `Mismatch! \nScanned: ${result} \nExpected: ${expectedValue}`,
                    "warning"
                  );
                  console.warn(
                    `Mismatch! Scanned: ${result}, Expected: ${expectedValue}`
                  );
                  setShowReScan(true);

                  // Restart the scanner after a mismatch
                  scannerInstance.clear().then(() => {
                    scannerInstance.render(
                      handleScanSuccess,
                      handleScanFailure
                    );
                  });
                  // scannerInstance.stop().then(() => {
                  //    scannerInstance.clear();
                  //   // // Restart the scanner
                  //   // scannerInstance.render(handleScanSuccess, handleScanFailure);
                  // }).catch((error) => {
                  //   console.error('Error stopping scanner: ', error);
                  // });
                }
              };

              const handleScanFailure = (error) => {
                console.warn("⚠️ Scan Error:", error);
              };

              scannerInstance.render(handleScanSuccess, handleScanFailure);

              scannerInstances.push(scannerInstance);
            }
          });
        })
        .catch((err) => {
          console.error("❌ Camera access error:", err);
          skiDIndexes.forEach((index) => {
            const scanElement = document.getElementById(`reader-${index}`);
            if (scanElement) {
              scanElement.innerHTML = `<span class="no-access grey-text">🚫 No Access Camera</span>`;
            }
          });
        });

      return () => {
        scannerInstances.forEach((scanner) => {
          try {
            if (scanner && typeof scanner.clear === "function") {
              scanner.clear().catch((err) => {
                console.warn("Error while clearing scanner:", err);
                alert("Error while clearing scanner:" + err);
              });
            }
          } catch (e) {
            console.warn("❌ Unexpected error while clearing scanner:", e);
            alert("Error while clearing scanner:" + e);
          }
        });
      };

      // return () => {
      //   scannerInstances.forEach((scanner) => {
      //     try {
      //       scanner.clear();
      //     } catch (e) {
      //       alert("Error clearing scanner:", e);
      //       console.warn("Error clearing scanner:", e);
      //     }
      //   });
      // };
    }
  }, [skidBreakdownDetailsList, scanResults]);

  // ✅ Function to reset scan
  const handleReScan = (index) => {
    setScanResults((prevResults) => {
      const updatedResults = { ...prevResults };
      delete updatedResults[index]; // ✅ Remove only the scanned value for the specific SkidIndex
      return updatedResults;
    });

    setIsVerifySuccess(0);
    setShowReScan(false); // Hide "ReScan" button temporarily
  };

  const handleChange = (event) => {
    event.preventDefault();

    const nospecial = /^[a-zA-Z0-9]+$/;
    const regexDecimal = /^[+-]?((\d+(\.\d*)?)|(\.\d+))$/;

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value.trim();

    if (fieldValue) {
      switch (fieldName) {
        case "DispatchWeight":
          if (
            regexDecimal.test(fieldValue) &&
            ((!fieldValue.includes(".") && fieldValue.length <= 6) ||
              (fieldValue.includes(".") &&
                fieldValue.split(".")[0].length <= 6 &&
                fieldValue.split(".")[1].length <= 2))
          ) {
            newAddDispatchDetails[fieldName] = fieldValue;
          }
          break;

        case "TrackingNumber":
          if (nospecial.test(fieldValue)) {
            newAddDispatchDetails[fieldName] = fieldValue;
          }
          break;

        default:
          newAddDispatchDetails[fieldName] = fieldValue;
          break;
      }
    } else {
      newAddDispatchDetails[fieldName] = "";
    }

    setDispatchDetails(newAddDispatchDetails);
  };

  // handle Dropdown Change function OrderAssign

  const handleCourierTypeDrpChange = (event, title) => {
    newAddDispatchDetails[title] = event?.value ? parseInt(event.value) : null;

    const selectedCourier = courierTypeDrpList.find(
      (item) => parseInt(item.value) === parseInt(event.value)
    );

    console.log("Selected Courier:", selectedCourier);
    console.log("Selected Courier IsSkipBoL:", selectedCourier?.IsSkipBoL);

    const isSkipBoL = selectedCourier?.IsSkipBoL ?? 0;

    if (title === "CourierTypeID") {
      newAddDispatchDetails.CourierTypeOptions = {
        value: parseInt(event.value),
        label: event.label,
        IsSkipBoL: isSkipBoL,
      };
      newAddDispatchDetails.IsSkipBOL = isSkipBoL;
      newAddDispatchDetails.CourierTypeName = event.label;
    }
    setDispatchDetails({ ...newAddDispatchDetails });
  };
  //OrderAssign Submit
  const handleDispatchDetailsSubmit = (event) => {
    showLoader();
    if (isVerifySuccess !== 1 && Number(listView?.IsSkipBOL) === 0) {
      hideLoader();
      Toastr(
        "Please verify all items are scanned before submitting.",
        "warning"
      );
      return;
    }
    event.preventDefault();
    var error = false;
    var errorMsg = "";
    const IsTrackingNumberExist = TrackingFields.some(
      (item, index) => item.TrackingNumber === ""
    );
    if (
      !newAddDispatchDetails.CourierTypeID ||
      !newAddDispatchDetails.DispatchWeight ||
      newAddDispatchDetails.DispatchWeight < 1 ||
      !newAddDispatchDetails.DigitalSignaturePath
    ) {
      error = true;
    }
    if (IsTrackingNumberExist) {
      error = true;
    }
    if (Number(newAddDispatchDetails?.CourierTypeOptions?.IsSkipBoL) === 1) {
      error = false;
    }

    if (!error) {
      newAddDispatchDetails.OrderID = listView.OrderID;
      newAddDispatchDetails.OrderNumber = listView.OrderNumber;
      newAddDispatchDetails.ClientID = listView.ClientID;
      newAddDispatchDetails.AssignedDispatcherID =
        listView.AssignedDispatcherID;
      newAddDispatchDetails.CourierTypeName =
        newAddDispatchDetails.CourierTypeOptions.label;
      newAddDispatchDetails.TypeOrderTrackingModel = TrackingFields;
      newAddDispatchDetails.IsPartyDeco = listView.IsPartyDeco;
      dispatch(orderActions.saveDispatchDetails(newAddDispatchDetails));
    } else {
      hideLoader();
      Toastr("Please fill in the required missing fields", "warning");
      setSubmitted(true);
    }
  };

  const handleClickImageClose = () => {
    newAddDispatchDetails.BillFilePath = newAddDispatchDetails.ImageBase64 = "";
    setDispatchDetails(newAddDispatchDetails);
    inputRef.current.value = null;
  };

  useEffect(() => {
    if (dispatchDetailsResponse === 1) {
      hideLoader();
      // dispatch(orderActions.clearOrderResponse());
      navigate("/OrderList");
      // Toastr('DispatchDetails updated successfully', "success");
      // setSubmitted(false);
      // setDispatchDetails(newAddDispatchDetails);
    }
  }, [dispatchDetailsResponse]);
  const handlechanges = () => {
    navigate("/OrderList");
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const UploadImages = async (e) => {
    const files = e.target.files;
    let file = files[0];

    if (file) {
      const fileType = file["type"];
      const validImageTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
      ];
      if (!validImageTypes.includes(fileType)) {
        Toastr("Invalid file format selected", "warning");
      } else {
        const MAX_FILE_SIZE = 5120; // 5MB
        const fileSizeKiloBytes = file.size / 1024;

        if (fileSizeKiloBytes > MAX_FILE_SIZE) {
          Toastr("File size is greater than maximum 5MB", "warning");
        } else {
          let base64 = await convertBase64(file);
          let formData = new FormData();
          formData.append("file", file);
          newAddDispatchDetails.ImageBase64 = base64;
          setDispatchDetails(newAddDispatchDetails);
        }
      }
    }
  };

  return (
    <>
      <PageTitle activeMenu="Dispatch Details" motherMenu="Order" />
      <ToastContainer />

      {Number(listView?.IsSkipBOL) === 0 && (
        <div className="card">
          <div className="product-float-sm-end">
            <Button
              style={{ float: "right" }}
              variant="btn btn-danger"
              onClick={handlechanges}
            >
              Back
            </Button>
            <div className="card-header">
              <h4 className="card-title">SkidBreakdown Details</h4>
            </div>
          </div>
          <div className="col-12">
            <div className="table-responsive">
              <div id="job_data" className="dataTables_wrapper">
                <table
                  className="display w-100 dataTable "
                  id="example5"
                  role="grid"
                  aria-describedby="example5_info"
                >
                  <thead>
                    <tr>
                      <th
                        rowSpan="2"
                        style={{
                          verticalAlign: "middle",
                          textAlign: "center",
                          width: "10px",
                        }}
                      >
                        Skid Number
                      </th>
                      <th
                        rowSpan="2"
                        style={{
                          verticalAlign: "middle",
                          textAlign: "center",
                          width: "10px",
                        }}
                      >
                        Skid Weight
                      </th>
                      <th
                        colSpan="3"
                        style={{
                          verticalAlign: "middle",
                          textAlign: "center",
                          width: "25%",
                        }}
                      >
                        Skid Dimensions
                      </th>
                      <th
                        rowSpan="2"
                        style={{
                          verticalAlign: "middle",
                          textAlign: "center",
                          width: "2px",
                        }}
                      >
                        Box #
                      </th>
                      <th
                        rowSpan="2"
                        style={{
                          verticalAlign: "middle",
                          textAlign: "center",
                          width: "2px%",
                        }}
                      >
                        Image
                      </th>
                      {listView.OrderStatusID !== 7 && (
                        <th
                          rowSpan="2"
                          style={{
                            verticalAlign: "middle",
                            textAlign: "left",
                            padding: "8px 112px",
                          }}
                        >
                          Scan
                        </th>
                      )}
                      {skidBreakdown &&
                        skidBreakdown.IsOrderSkidBreakdown === false && (
                          <th
                            rowSpan="2"
                            style={{
                              verticalAlign: "middle",
                              textAlign: "center",
                              width: "280px",
                            }}
                          >
                            Verification
                          </th>
                        )}
                    </tr>
                    <tr>
                      <th scope="col">L</th>
                      <th scope="col">W</th>
                      <th scope="col">H</th>
                    </tr>
                  </thead>
                  <tbody>
                    {skidBreakdownDetailsList &&
                    skidBreakdownDetailsList?.TypeOrderSkidBreakdownModel &&
                    skidBreakdownDetailsList?.TypeOrderSkidBreakdownModel
                      .length > 0 ? (
                      <>
                        {(() => {
                          return skidBreakdownDetailsList?.TypeOrderSkidBreakdownModel?.map(
                            (inputField) => {
                              console.log("inputField:", inputField); // ✅ Logs each inputField to the console

                              if (!inputField.IsDeleted) {
                                // ✅ More readable condition
                                return (
                                  <Fragment
                                    key={`OrderSkidBreakdown_${inputField.SkidIndex}`}
                                  >
                                    <tr className="odd" role="row">
                                      <td>
                                        {newAddDispatchDetails.OrderNumber +
                                          "-" +
                                          inputField.SkidIndex}
                                      </td>
                                      <td>
                                        <label>{inputField.SkidWeight}</label>
                                      </td>
                                      <td>
                                        <label>
                                          {inputField.SkidDimensionLength}
                                        </label>
                                      </td>
                                      <td>
                                        <label>
                                          {inputField.SkidDimensionWeight}
                                        </label>
                                      </td>
                                      <td>
                                        <label>
                                          {inputField.SkidDimensionHeight}
                                        </label>
                                      </td>
                                      <td>
                                        <label>
                                          {inputField.SkidBoxNumbers}
                                        </label>
                                      </td>

                                      <td className="new-width">
                                        {inputField.ImageFilePath ||
                                        inputField.ImageBase64 ? (
                                          <img
                                            style={{
                                              height: "74px",
                                              width: "100px",
                                            }}
                                            className="center-width-img"
                                            src={
                                              skidBreakdown.IsOrderSkidBreakdown
                                                ? REACT_APP_API_IMAGE_URL +
                                                  inputField.ImageFilePath
                                                : !inputField.ImageBase64
                                                ? REACT_APP_API_IMAGE_URL +
                                                  inputField.ImageFilePath
                                                : inputField.ImageBase64
                                            }
                                            alt="Card_image_cap"
                                          />
                                        ) : (
                                          <img
                                            style={{
                                              height: "74px",
                                              width: "100px",
                                            }}
                                            className="center-width-img"
                                            src={emptyImage}
                                            alt="Card_image_cap"
                                          />
                                        )}
                                      </td>
                                      {listView.OrderStatusID !== 7 && (
                                        <td>
                                          <div
                                            id={`reader-${inputField.SkidIndex}`}
                                            style={{
                                              // display: scanResults[inputField.SkidIndex] ? "none" : "block",
                                              //display: scanResults[inputField.SkidIndex] ? "block" : "block",
                                              display: "block",
                                              width: "280px",

                                              height: "auto",
                                              borderRadius: "18px",
                                              border: "1px solid #ccc",
                                            }}
                                          ></div>

                                          {scanResults[
                                            inputField.SkidIndex
                                          ] && (
                                            <button
                                              onClick={() =>
                                                handleReScan(
                                                  inputField.SkidIndex
                                                )
                                              } // ✅ Resets only the specific scanner
                                              style={{
                                                backgroundColor: "#007bff",
                                                color: "white",
                                                border: "none",
                                                padding: "8px 16px",
                                                borderRadius: "8px",
                                                cursor: "pointer",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              🔄 ReScan
                                            </button>
                                          )}
                                        </td>
                                      )}
                                      <td
                                        style={{
                                          textAlign: "center",
                                          width: "50px",
                                        }}
                                      >
                                        <span
                                          className="badge"
                                          style={{
                                            backgroundColor: "white", // Keep background white
                                            color:
                                              listView.OrderStatusID !== 7
                                                ? scanResults[
                                                    inputField.SkidIndex
                                                  ]
                                                  ? "#28a745"
                                                  : "#dc3545"
                                                : "#28a745", // Green or Red text
                                            border: `2px solid ${
                                              listView.OrderStatusID !== 7
                                                ? scanResults[
                                                    inputField.SkidIndex
                                                  ]
                                                  ? "#28a745"
                                                  : "#dc3545"
                                                : "#28a745"
                                            }`, // Border color
                                            borderRadius: "10px", // Rounded edges
                                            padding: "6px 12px", // Proper spacing
                                            fontSize: "15px", // Readable text size
                                            fontWeight: "bold",
                                            minWidth: "100px", // Consistent width
                                            display: "inline-block", // Ensures proper positioning
                                            textAlign: "center",
                                            whiteSpace: "nowrap", // Prevents wrapping
                                          }}
                                        >
                                          {listView.OrderStatusID !== 7
                                            ? scanResults[inputField.SkidIndex]
                                              ? "  Verified"
                                              : "  Not Verified"
                                            : "Verified"}
                                        </span>
                                      </td>
                                    </tr>
                                  </Fragment>
                                );
                              }

                              return null;
                            }
                          );
                        })()}
                      </>
                    ) : (
                      <tr>
                        <td colSpan="11" className="norecordfound">
                          <span>No Records Found</span>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="col-12">
        <OrderDatatable orderId={listView.OrderID} />
      </div>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Dispatch Details</h4>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <label className="text-black font-w700">
                      Courier<span className="text-danger">*</span>
                    </label>
                    <Select
                      classNamePrefix={"custom_select_css"}
                      name="CourierTypeID"
                      value={newAddDispatchDetails.CourierTypeOptions}
                      onChange={(event) =>
                        handleCourierTypeDrpChange(event, "CourierTypeID")
                      }
                      options={courierTypeDrpList}
                      styles={
                        submitted && !newAddDispatchDetails.CourierTypeOptions
                          ? styles
                          : ""
                      }
                      isDisabled={listView.OrderStatusID === 7 ? true : false}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="text-black font-w700">
                      Dispatch Weight(lbs)
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      className={`form-control ${
                        listView.OrderStatusID === 7 && "readonly_css"
                      } ${
                        submitted &&
                        (!newAddDispatchDetails.DispatchWeight ||
                          parseFloat(
                            newAddDispatchDetails.DispatchWeight &&
                              newAddDispatchDetails.DispatchWeight
                          ) < 1) &&
                        "border-danger"
                      }`}
                      type="text"
                      name="DispatchWeight"
                      placeholder="Dispatch Weight(lbs)"
                      value={newAddDispatchDetails.DispatchWeight}
                      onChange={handleChange}
                      readOnly={listView.OrderStatusID === 7 ? true : false}
                    />
                  </div>
                </div>

                {(() => {
                  return (
                    newAddDispatchDetails?.CourierTypeOptions?.label &&
                    Number(
                      newAddDispatchDetails?.CourierTypeOptions?.IsSkipBoL
                    ) === 0 && (
                      <div className="row">
                        <div className="col-lg-6" style={{ marginTop: "10px" }}>
                          <label className="text-black font-w700">
                            Digital Signature
                            <span className="text-danger">*</span>
                          </label>
                          {listView.OrderStatusID !== 7 && (
                            <SignatureCanvas
                              penColor="black"
                              canvasProps={{
                                width: 500,
                                height: 200,
                                className: `signature ${
                                  submitted &&
                                  !newAddDispatchDetails.DigitalSignaturePath &&
                                  "border-danger "
                                }`,
                              }}
                              ref={sigRef}
                              value={newAddDispatchDetails.DigitalSignaturePath}
                              onEnd={handleSignatureEnd}
                            />
                          )}
                          {listView.OrderStatusID !== 7 && (
                            <li
                              title="Clear"
                              onClick={(e) => clearSignature(e)}
                              className="btn btn-primary shadow btn-xs sharp me-3 Signature_Clear"
                            >
                              <i className="fas fa-sync-alt"></i>
                            </li>
                          )}
                          {listView.OrderStatusID === 7 && (
                            <div className="">
                              <div>
                                <img
                                  style={{
                                    height: "170px",
                                    border: "1px solid",
                                  }}
                                  className="card-img-top"
                                  src={
                                    REACT_APP_API_IMAGE_URL +
                                    newAddDispatchDetails.DigitalSignaturePath
                                  }
                                  alt="Card_image_cap"
                                />
                              </div>
                            </div>
                          )}
                        </div>

                        <div
                          className="col-lg-6 mb-3 bill-upload-section"
                          style={{ marginTop: "10px" }}
                        >
                          <label className="text-black font-w700">
                            Bill of Lading upload
                          </label>

                          <div className="col-md-9 mb-3">
                            {newAddDispatchDetails.BillFilePath ||
                            newAddDispatchDetails.ImageBase64 ? (
                              <div className="card">
                                <div className="card-header">
                                  {listView.OrderStatusID !== 7 && (
                                    <span className="float-right">
                                      <i
                                        onClick={() => handleClickImageClose()}
                                        className="fas fa-times productImageClose"
                                      ></i>
                                    </span>
                                  )}
                                </div>
                                {listView.OrderStatusID !== 7 ? (
                                  <img
                                    style={{ height: "170px" }}
                                    className="card-img-top"
                                    src={
                                      !newAddDispatchDetails.ImageBase64
                                        ? REACT_APP_API_IMAGE_URL +
                                          newAddDispatchDetails.BillFilePath
                                        : newAddDispatchDetails.ImageBase64
                                    }
                                    alt="Card_image_cap"
                                  />
                                ) : (
                                  <img
                                    style={{
                                      height: "170px",
                                      position: "absolute",
                                    }}
                                    className="card-img-top"
                                    src={
                                      !newAddDispatchDetails.ImageBase64
                                        ? REACT_APP_API_IMAGE_URL +
                                          newAddDispatchDetails.BillFilePath
                                        : newAddDispatchDetails.ImageBase64
                                    }
                                    alt="Card_image_cap"
                                  />
                                )}
                              </div>
                            ) : (
                              <div className="card">
                                {newAddDispatchDetails.BillFilePath ||
                                newAddDispatchDetails.ImageBase64 ? (
                                  <img
                                    style={{ height: "170px" }}
                                    className="card-img-top"
                                    src={
                                      !newAddDispatchDetails.ImageBase64
                                        ? REACT_APP_API_IMAGE_URL +
                                          newAddDispatchDetails.BillFilePath
                                        : newAddDispatchDetails.ImageBase64
                                    }
                                    alt="Card_image_cap"
                                  />
                                ) : (
                                  <img
                                    style={{ height: "170px" }}
                                    className="card-img-top"
                                    src={emptyImage}
                                    alt="Card_image_cap"
                                  />
                                )}
                              </div>
                            )}
                          </div>
                          {listView.OrderStatusID === 7 || (
                            <div className="input-group mb-3">
                              <div className="form-file">
                                <input
                                  type="file"
                                  ref={inputRef}
                                  onChange={(event) => UploadImages(event)}
                                  className={`custom-file-input form-control ${submitted}`}
                                />
                              </div>
                              <span className="input-group-text">Upload</span>
                            </div>
                          )}
                        </div>
                      </div>
                    )
                  );
                })()}

                {/* {listView.OrderStatusID !== 7 &&
                  <div className="plus">
                    {newAddDispatchDetails.TypeOrderTrackingModel && TrackingFields && TrackingFields.length < 8 &&
                      <Button
                        // onClick={handleAddFields}
                        onClick={() => handleAddFields()}
                        // onClick={() => handleCancelOrder(row.original)}
                        title="Add Tracking Number"
                        className="btn btn-primary-color shadow btn-xs sharp me-1"
                      >
                        <i className="fa fa-plus"></i>

                      </Button>
                    }

                  </div>
                } */}

                <div className="col-md-6 tracking-number-section ">
                  <div className="addButton">
                    <label className="text-black font-w700">
                      Tracking Number<span className="text-danger">*</span>
                    </label>
                    {listView.OrderStatusID !== 7 && (
                      <div>
                        {newAddDispatchDetails?.TypeOrderTrackingModel &&
                          TrackingFields &&
                          TrackingFields.length < 8 && (
                            <Button
                              // onClick={handleAddFields}
                              onClick={() => handleAddFields()}
                              // onClick={() => handleCancelOrder(row.original)}
                              title="Add Tracking Number"
                              className="btn btn-primary-color shadow btn-xs sharp me-1"
                            >
                              <i className="fa fa-plus"></i>
                            </Button>
                          )}
                      </div>
                    )}
                  </div>

                  {TrackingFields.map((item, index) => (
                    <div key={index}>
                      <div className="tracking-number-delete ">
                        <input
                          style={{ marginTop: "10px" }}
                          className={`form-control ${
                            ((submitted &&
                              TrackingFields[index].TrackingNumber === "") ||
                              (FieldError === true &&
                                TrackingFields[index].TrackingNumber === "")) &&
                            "border-danger"
                          }`}
                          // className={`form-control ${TrackingFields[index]?.TrackingNumber ? 'border-danger' : ''}`}
                          type="text"
                          name="TrackingNumber"
                          placeholder="Tracking Number"
                          value={item.TrackingNumber}
                          onChange={(event) => handleInputChange(index, event)}
                          maxLength={28}
                        />
                        {listView.OrderStatusID !== 7 && index !== 0 && (
                          <div
                            onClick={() => handleRemoveFields(index)}
                            title="Delete"
                            className="btn btn-danger-color shadow btn-xs sharp me-1"
                          >
                            <i className="fa fa-trash"></i>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="row">
                  {listView.OrderStatusID === 7 || (
                    <div className="col-12">
                      <Button
                        style={{ float: "right" }}
                        onClick={handleDispatchDetailsSubmit}
                        className="btn btn-primary mt-3 mb-3"
                      >
                        Submit
                      </Button>
                      {/* <button style={{ float: "right" }} className="btn btn-danger shadow mb-2 me-2">
                                            Cancel
                                        </button> */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loader}
    </>
  );
};

export default DispatchDetails;
